<blaze-dialog
  (closeDialog)="closeDialog()"
  [formGroup]="form"
  [showCloseButton]="true"
  [showFooter]="true"
  [showHeader]="true"
  class="referral-dialog"
>
  <mat-icon class="icon-16 !text-primary-lighter" icon svgIcon="icon_blaze_16" />
  <div title>Refer a Team to Blaze</div>

  <div content class="flex flex-col gap-24 text-primary-darker">
    <div class="flex flex-row gap-16 items-center">
      <div class="gift-icon">
        <mat-icon svgIcon="gift_40" />
      </div>
      <div class="text-14">
        Give another team their breakthrough — introduce them to Blaze. When they come on board, you
        each get $1,000, as a gift card or credit toward your Blaze account.
      </div>
    </div>

    <div class="form-cols">
      <div class="form-col">
        <div class="label">Your name</div>
        <input type="text" class="bd-text-input" disabled value="{{ name() }}" />
      </div>
      <div class="form-col">
        <div class="label">Your email</div>
        <input type="text" class="bd-text-input" disabled value="{{ user()?.email }}" />
      </div>
    </div>

    <hr class="text-base-light w-full" />

    <div class="font-medium text-primary">Whom You Are Referring</div>

    <div class="form-cols">
      <div class="form-col">
        <div class="label">Their name</div>
        <input type="text" class="bd-text-input" required formControlName="name" />
        <div class="error">
          @if (form | showFormError: 'name' : 'required') {
            This field is required.
          }
        </div>
      </div>
      <div class="form-col">
        <div class="label">Their work email</div>
        <input type="text" class="bd-text-input" required formControlName="email" />
        <div class="error">
          @if (form | showFormError: 'email' : 'required') {
            This field is required.
          }
          @if (form | showFormError: 'email' : 'email') {
            This field must be a valid email address.
          }
        </div>
      </div>
    </div>

    <div class="form-cols">
      <div class="form-col">
        <div class="label">Company (optional)</div>
        <input type="text" class="bd-text-input" formControlName="company" />
      </div>
      <div class="form-col">
        <div class="label">How do you know them?</div>

        <blaze-select
          [allowNone]="false"
          [multiselect]="false"
          [options]="howDoYouKnowOptions"
          [showNoneOption]="false"
          [showSelection]="true"
          filterPlaceholder="Select one"
          formControlName="source"
        />

        @if (form.get('source')?.value === 'Other') {
          <input
            class="bd-text-input"
            formControlName="sourceTyped"
            placeholder="How do you know them"
            type="text"
          />
        }
      </div>
    </div>

    <div class="form-cols">
      <div class="form-col">
        <div class="label">What should we know about them (optional)</div>
        <textarea
          class="bd-textarea !min-h-[64px]"
          formControlName="additionalInfo"
          placeholder="What are they trying to build, or what made you think of them?"
        ></textarea>
      </div>
    </div>
  </div>

  <div footer class="flex flex-col gap-8 w-full items-center justify-center">
    <button blazeButton="primary" class="uppercase w-full" (click)="onSendReferral()">
      Send Referral
    </button>
    <div class="text-primary-darker text-11">
      This sends the details to the Blaze team. We'll follow up with your referral personally.
    </div>
  </div>
</blaze-dialog>
